$(document).on('change','.custom_select', function() {
    var val = $(this).val();
    $('[value="'+val+'"]').click();
    var title = '';
    $('variant-selects .product-form__input').each(function(){
        title += '-'+$(this).find(":selected").val();
    })
   
    const result = title.slice(1);
    const amount = $('.variant-data[data-v-title="'+result+'"]').data('strikeprice');
    const original = $('.variant-data[data-v-title="'+result+'"]').data('v-price');
    const currency = $('body').attr('currency');
    if (amount !== '' && amount !== undefined) {
      $('.strikeprice').css('display', 'block');
      $('.strikeprice').html(`
        <h3>Join the club & Save</h3>
        <span style="font-weight: bold;" id="strikeprice-value" class="compareprice">${currency}${amount}</span>
        <span class="realprice money pre-money original-price">${original}</span>
      `);
    } else {
      $('.strikeprice').html('');
      $('.strikeprice').css('display', 'none');
    }
    
    
    setTimeout(function () {
      if($('.product-form__buttons button[disabled]').length){
        $('.product_badge span.badge').text('Sold Out');
      }else{
        $('.product_badge span.badge').text('In Stock');
        $('.product_badge span.badge.sale').text('Sale');
      }
    },2000)
});
$(document).on('click','.custom-Size label',function () {
   
  setTimeout(function () {
      if($('.product-form__buttons button[disabled]').length){
        $('.product_badge span.badge').text('Sold Out');
      }else{
        $('.product_badge span.badge').text('In Stock');
        $('.product_badge span.badge.sale').text('Sale');
      }
      var title = '';
      $('variant-radios fieldset').each(function(){
          title += '-'+$(this).find('input[type="radio"]:checked').val();
      })
      var result = title.slice(1);
      var amount = $('.variant-data[data-v-title="'+result+'"]').data('strikeprice');
      $('.strikeprice span').text(amount);
    },2000)
})

$(document).ready(function () {
 setTimeout(function () {
    if($('.product-form__buttons button[disabled]').length){
      $('.product_badge span.badge').text('Sold Out');
    }else{
      $('.product_badge span.badge').text('In Stock');
      $('.product_badge span.badge.sale').text('Sale');
    }
  },2000)

$('.product__accordion').click(function(){
    $(this).find('.accordion__content').slideToggle();
    $(this).find('.accordian-quest').toggleClass('open');
    $(this).siblings().find('.accordian-quest').removeClass('open');
    $(this).siblings().find('.accordion__content').slideUp()
})

var checkint = setInterval(function() {
  if($('.section-related-products product-recommendations .product-grid').length){
    if($('.section-related-products product-recommendations .product-grid.slick-initialized').length){
      
    }else{
      $('.section-related-products product-recommendations .product-grid').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          cssEase: 'linear',
          arrows: true,
          prevArrow: '<svg width="8" class="left-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 1L1.5 6L6.5 11" stroke="#527769" stroke-width="1.5"/></svg>',
          nextArrow: '<svg width="8" class="right-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="#527769" stroke-width="1.5"/></svg>',
          responsive: [
                {
                  breakpoint: 1500,
                  settings: {
                    slidesToShow: 3
                  }
                },
                {
                    breakpoint: 483,
                    settings: {
                      slidesToShow: 2
                    }
                }
            ]
      });
    }
    clearInterval(checkint)
    
  }
},300)
})